import { UiElementTypes } from '@store/types/uiElementTypes'

export const uiElementInitial: UiElementTypes = {
  isToast: false
}
